import React from 'react';
import './RaffleSoon.scss';

const RaffleSoon = () => {
  return <div className="raffle-soon-component">
      <img src={require('../../../../../images/icons/viper-icon.svg').default} alt="viper"/>
      <h2>Winners soon to be announced</h2>
      <span>First raffle will be held on <b>June 17th</b></span>
  </div>
};

export default RaffleSoon;
